export type Action = {
  type: string;
  selector: string;
  wait: number;
  props?: {
    type: string;
  };
};

let actionStack: Action[] = [];

let actionTimeout = null;

export function initActionStack(actions: Action[]) {
  actionStack = [...actions];
}

export function clearActionTimeout() {
  if (actionTimeout) {
    clearTimeout(actionTimeout);
    actionTimeout = null;
  }
}

export function playActions() {
  if (actionStack.length == 0) {
    return;
  }
  if (actionStack[0].wait == 0) {
    playAction();
  } else {
    actionTimeout = setTimeout(() => {
      playAction();
    }, actionStack[0].wait * 1000);
  }
}

const globalCursors = [];

function hasCursor(element) {
  const document = element.ownerDocument;
  return document.getElementById("hand-cursor") != null;
}

function getCursor(element) {
  const document = element.ownerDocument;
  let cursor = document.getElementById("hand-cursor");
  if (cursor == null) {
    cursor = document.createElement("img");
    cursor.id = "hand-cursor";
    cursor.src = "/images/cursor-hand.svg";
    cursor.style.position = "absolute";
    cursor.style.zIndex = "1000";
    cursor.style.pointerEvents = "none";
    cursor.style.width = "32px";
    cursor.style.height = "32px";
    cursor.style.transition = "all 1s";
    globalCursors.push(cursor);
    document.body.appendChild(cursor);
  }
  return cursor;
}

function getMultiplier() {
  const style = window.getComputedStyle(document.querySelector(".slides"));
  const scale = parseFloat(
    style.transform.split("(")[1].split(")")[0].split(",")[0]
  );
  return scale;
}

function showCursor(element) {
  // we are playing new action we stop hiding cursor
  clearTimeout(hideTimeout);

  const cursor = getCursor(element);
  cursor.style.display = "block";
  return cursor;
}

function hideCursor() {
  console.log("Hiding cursor");
  while (globalCursors.length > 0) {
    const cursor = globalCursors.pop();
    cursor.remove();
  }
}

function animateCursor(element) {
  // we are playing new action we stop hiding cursor
  clearTimeout(hideTimeout);

  return new Promise<void>((resolve) => {
    const existingCursor = hasCursor(element);
    const cursor = getCursor(element);

    const rect = element.getBoundingClientRect();
    const center = {
      x: rect.left + rect.width / 2 - 16,
      y: rect.top + rect.height / 2,
    };

    if (!existingCursor) {
      cursor.style.left = `${center.x + 50}px`;
      cursor.style.top = `${center.y - 30}px`;
    }

    // show cursor
    showCursor(element);

    if (
      Math.round(parseFloat(cursor.style.left)) === Math.round(center.x) &&
      Math.round(parseFloat(cursor.style.top)) === Math.round(center.y)
    ) {
      resolve();
    }

    // now animate to position
    setTimeout(() => {
      cursor.style.left = `${center.x}px`;
      cursor.style.top = `${center.y}px`;
      setTimeout(() => {
        resolve();
      }, 1000);
    }, 500);
  });
}

function findElementInDocument(document, selector: string) {
  let element = null;
  if (selector.startsWith("#")) {
    element = document.querySelector(selector);
  } else if (selector.startsWith(".")) {
    element = document.querySelector(selector);
  } else if (selector.startsWith("text|")) {
    const parts = selector.split("|");
    let elementsWithText: HTMLDivElement[] = Array.from(
      document.querySelectorAll("*")
    );
    elementsWithText = elementsWithText.filter(
      (element) => element.textContent.trim() === parts[1]
    );
    if (elementsWithText.length > 0) {
      element = elementsWithText[0];
    }
  } else if (selector.indexOf("|") > 0) {
    const parts = selector.split("|");
    let elementsWithText: HTMLDivElement[] = Array.from(
      document.querySelectorAll(parts[0])
    );
    if (parts[1]) {
      elementsWithText = elementsWithText.filter(
        (element) => element.textContent.trim() === parts[1]
      );
    }
    if (elementsWithText.length > 0) {
      element = elementsWithText[0];
    }
  } else {
    element = document.querySelector(selector);
  }
  return element;
}

function findElement(
  selector,
  document: Element | Document = Reveal.getCurrentSlide()
) {
  // we will start with the innermost iframe
  const iframes = document.querySelectorAll("iframe");
  for (const frame of iframes) {
    const element = findElement(selector, frame.contentDocument);
    if (element != null) {
      return element;
    }
  }
  return findElementInDocument(document, selector);
}

let hideTimeout = null;

async function playAction() {
  const action = actionStack.shift();

  // we are playing new action we stop hiding cursor
  clearTimeout(hideTimeout);

  if (action.wait) {
    console.log(`Waiting for ${action.wait} seconds`);
    await new Promise((resolve) => setTimeout(resolve, action.wait * 1000));
  }

  if (action.type == "hideCursor") {
    hideCursor();
  } else {
    const element = findElement(action.selector);
    if (element == null) {
      console.error(`Element not found: ${action.selector}`);
    } else if (action.type == "click") {
      await animateCursor(element);
      const cursor = getCursor(element);
      cursor.src = "/images/cursor-hand-clicked.svg";
      await new Promise(
        (resolve) => (actionTimeout = setTimeout(resolve, 100))
      );
      cursor.src = "/images/cursor-hand.svg";
      await new Promise(
        (resolve) => (actionTimeout = setTimeout(resolve, 400))
      );
      element.click();
      hideTimeout = setTimeout(() => hideCursor(), 1000);
    } else if (action.type == "type") {
      for (let i = 0; i < action.props?.type.length; i++) {
        // const inputEvent = new Event("change", { bubbles: true });
        // element.value = (action.props?.type || "").substring(0, i + 1);
        // element.dispatchEvent(inputEvent);

        const newValue = (action.props?.type || "").substring(0, i + 1);

        // Set the value programmatically
        Object.getOwnPropertyDescriptor(
          window.HTMLInputElement.prototype,
          "value"
        ).set.call(element, newValue);

        // Dispatch the 'input' event to trigger React's onChange
        const event = new Event("input", { bubbles: true });
        element.dispatchEvent(event);

        await new Promise((resolve) => setTimeout(resolve, 30));
      }
    } else if (action.type == "execute") {
      await element.__runner?.();
    } else if (action.type == "showCursor") {
      await animateCursor(element);
    }
  }

  // continue playing actions
  playActions();
}
